/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React,{useState} from 'react'
import ReactModal from 'react-modal'
import EubSummarySection from '../../Pages/CartManagement/EubSummarySection'
import PlacedOrderSection from '../../Pages/CartManagement/EubSummarySection'
import PlaceOrderSection from '../../Pages/MyOrders/ViewOrder/Components/PlacedOrderSection'
import { PriceHandler } from '../../redux/helper/CamelCase'
import { checkAssistant } from '../../redux/helper/CheckAssistant'
import DocumentModal from '../CartItemCard/DocumentModal'
import AcceptRejectBlock from './AcceptRejectBlock'
import AdorCashSection from './AdorCashSection'
import DistributorComments from './DistributorComments'
import OrderCancelledButton from './OrderCancelledButton'

export default function OrderNormalSummary({
    OrderData,
    documentData,
    orderFlow,
    loader,
    adorCashCheck,
    setadorCashCheck
    ,setloader,
    setacceptRejectPopup,
    documnet,
    setdocument,
    Privilages,
    handleStatusApprove}) {
    const [distributorCommentPopup, setdistributorCommentPopup] = useState(false)


    return (
        <div className="lg:min-w-[30%] min-w-full lg:mt-0 mt-4 lg:ml-[17px]">
            <div className="border border-[#CBC7C7] px-4 pt-[18px] rounded-md bg-[#F5F5FA] pb-4">
                <div className="border-b border-[#CBCBCB] pb-2.5">
                    <div className="flex justify-between items-center">
                        <p className="text-sm font-semibold text-[#090406]">Order Type</p>
                        {/* <!-- <p class="font-normal text-xs3 text-[#555259]">Total Order Qty.: 15,000 kg</p> --> */}
                    </div>
                    <p className="sm:text-lg text-base font-normal text-[#555259]">{OrderData.order.order_type}</p>
                </div>
                <div className="mt-3 border-b border-[#CBCBCB]">
                    <p className="text-sm font-semibold text-[#090406]">Quantity</p>
                    <div className="items-center flex justify-between mt-2">
                        <p className="font-normal text-sm text-[#555259]">Line Items selected</p>
                        <p className="font-normal text-sm text-[#555259]">{OrderData?.order.total_items}</p>
                    </div>
                    <div className="items-center flex justify-between mt-2 pb-3">
                        <p className="font-normal text-sm text-[#555259]">Net Order Quantity</p>
                        {Object.keys(OrderData?.order?.summary?.quantity).length>0 &&
                        Object.keys(OrderData?.order?.summary?.quantity).map((UOM,i)=>(
                            <p  style={{float: `${i===0?'':'right'}`}} key={UOM} className={`font-normal text-sm text-[#555259]`}>{Number(OrderData?.order?.summary?.quantity[UOM])} {UOM} <br/></p>
                        ))}
                    </div>
                </div>
                <div className="pt-1.5">
                    <div>
                        <p className="sm:text-lg text-base font-semibold text-[#090406]">Order Summary</p>
                        
                        <PlaceOrderSection Privilages={Privilages} adorCashCheck={adorCashCheck} setadorCashCheck={setadorCashCheck} setacceptRejectPopup={setacceptRejectPopup} Calculation={OrderData.order.summary} orderFlow="order" GetCalculation={()=>console.log('Draft')} OrderData={OrderData?.order}/>
                    </div>
                </div>
                <OrderCancelledButton OrderData={OrderData}/>

                {OrderData.order.status==="0" && !checkAssistant() &&
                <>

                    <div className="flex justify-center items-center" onClick={()=>setdistributorCommentPopup(!distributorCommentPopup)}>
                        <p className="text-center text-sm font-semibold text-[#000000] py-4 pr-3 cursor-pointer" data-bs-toggle="modal" data-bs-target="#addDocumnetation">View Distributor Comments</p>
                        <img src="/images/Path-2635.svg" alt="icon" />
                    </div>
                    <div className='pt-5'>
                        <AcceptRejectBlock setacceptRejectPopup={setacceptRejectPopup}/>
                    </div>
                    <ReactModal style={{overFlow:'auto'}} isOpen={distributorCommentPopup}>
                        <DocumentModal
                            setdocumentModal={setdistributorCommentPopup}
                            documentModal={distributorCommentPopup}
                            documentData={documentData}
                            setdocument={setdocument}
                            orderFlow={orderFlow}
                            loader={loader}
                            setloader={setloader}
                            handleSubmit={handleStatusApprove}
                            isdraft
                        />
                    </ReactModal>
                </>
                
                }
                <AdorCashSection OrderData={OrderData} adorKey="order_avail_ador_cash"/>

            </div>
            <div className="border border-[#CBC7C7] rounded-md bg-[#F5F5FA] h-auto p-3 my-4" data-testid="eu-name-view">
                <p className="font-semibold text-base text-[#090406]">End User Customer Name</p>
                <div className="flex items-center mt-1">
                    {OrderData?.order?.eu_name ? (
                        <>
                            <span className="w-7 h-7 rounded-full bg-[#555259] text-white text-xs font-semibold flex items-center justify-center mr-2 flex-shrink-0">
                                {OrderData.order.eu_name.charAt(0).toUpperCase()}
                            </span>
                            <p className="font-normal text-sm text-[#555259]" data-testid="eu-name-value">{OrderData.order.eu_name}</p>
                        </>
                    ) : (
                        <p className="font-normal text-sm text-[#555259]" data-testid="eu-name-value">-</p>
                    )}
                </div>
            </div>
            <DistributorComments OrderData={OrderData}/>
            {/* <DistributorComments OrderData={OrderData}/> */}
            {/* <!-- <div class="border border-[#CBC7C7 rounded-md bg-[#F5F5FA] h-auto p-3 my-4">
                        <p class="font-semibold text-base text-[#090406]">Related Documents</p>
                        <div class="flex items-center justify-start">
                            <img src="/images/red-dot.svg" alt=""/>
                            <p class="ml-2 mr-3 font-normal text-base text-black">PO Document</p>
                            <div class="flex items-center">
                                <img src="/images/download.svg" alt=""/>
                                <p class="text-[#5B5B5B] text-xs3 font-semibold ml-1">Download</p>
                            </div>
                        </div>
                    </div> --> */}
        </div>
    )
}
